import React, { useState } from "react";
import {
    Box,
    Card,
    Typography,
    Radio,
    Divider,
    Avatar,
    Button,
    Switch,
} from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Header from "../components/header.tsx";
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EastIcon from '@mui/icons-material/East';
import Footer from "../components/footer.tsx";
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import { isMobile } from "react-device-detect";

const initialItems = [
    {
        id: 1,
        name: 'Tablet',
        price: 49.99,
        oldPrice: 59.99,
        quantity: 2,
        image: deals_1,
        availability: 'In Stock',
        rating: 4
    },
    {
        id: 2,
        name: 'Wireless Headphone',
        price: 29.99,
        oldPrice: 49.99,
        quantity: 1,
        image: deals_2,
        availability: 'In Stock',
        rating: 3.5
    },
];

const PaymentMethod = () => {
    const [selected, setSelected] = useState<"upi" | "card" | "wallet" | "cod">("upi");
    const [items, setItems] = useState(initialItems);

    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* payment method */}
            <Box
                minHeight="100vh"
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                alignItems={{ xs: "stretch", md: "flex-start" }}
                justifyContent="center"
                bgcolor="#f9f9f9"
                p={2}
                gap={3}
            >
                {/* payment method */}
                <Box width={{ md: "100%" }}>
                    <Card sx={{ p: 4, borderRadius: 3/* , width: isMobile ? '' : "100%"  */ }}>
                        <Typography variant="h6" mb={3}>
                            Select Payment Method
                        </Typography>

                        {/* UPI Card */}
                        <Card
                            onClick={() => setSelected("upi")}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                border: selected === "upi" ? "2px solid #C32032" : "1px solid #ccc",
                                cursor: "pointer",
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <Radio checked={selected === "upi"} />
                                <PhoneIphoneIcon sx={{ color: '#C32032' }} />
                                <Box>
                                    <Typography fontWeight="bold">UPI</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Pay instantly using your UPI ID
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            <Box display="flex" gap={2} justifyContent="start">
                                <Avatar src="/upi1.png" variant="rounded" sx={{ width: 56, height: 56 }} />
                                <Avatar src="/upi2.png" variant="rounded" sx={{ width: 56, height: 56 }} />
                                <Avatar src="/upi3.png" variant="rounded" sx={{ width: 56, height: 56 }} />
                            </Box>
                        </Card>

                        {/* Credit/Debit Card */}
                        <Card
                            onClick={() => setSelected("card")}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                border: selected === "card" ? "2px solid #C32032" : "1px solid #ccc",
                                cursor: "pointer",
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <Radio checked={selected === "card"} />
                                <CreditCardIcon sx={{ color: '#C32032' }} />
                                <Box>
                                    <Typography fontWeight="bold">Credit/Debit Card</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        All major cards accepted
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>

                        {/* digital wallet */}
                        <Card
                            onClick={() => setSelected("wallet")}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                border: selected === "wallet" ? "2px solid #C32032" : "1px solid #ccc",
                                cursor: "pointer",
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <Radio checked={selected === "wallet"} />
                                <AccountBalanceWalletOutlinedIcon sx={{ color: '#C32032' }} />
                                <Box>
                                    <Typography fontWeight="bold">Digital Wallet</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Pay using your digital wallet
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>

                        {/* Cash on Delivery */}
                        <Card
                            onClick={() => setSelected("cod")}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                border: selected === "cod" ? "2px solid #C32032" : "1px solid #ccc",
                                cursor: "pointer",
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <Radio checked={selected === "cod"} />
                                <LocalShippingIcon sx={{ color: '#C32032' }} />
                                <Box>
                                    <Typography fontWeight="bold">Cash on Delivery</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Pay when your order arrives
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>

                        {/* save payment method */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                            <Typography>Save payment method for future use</Typography>
                            <Switch />
                        </Box>

                        {/* note */}
                        <Card
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <ShieldOutlinedIcon sx={{ color: 'gray' }} />
                                <Typography sx={{ color: 'gray' }}>Your payment option is secure</Typography>
                            </Box>

                            <Box display="flex" alignItems="center" gap={1}>
                                <LockOutlinedIcon sx={{ color: 'gray' }} />
                                <Typography sx={{ color: 'gray' }}>Encrypted and protected transactions</Typography>
                            </Box>
                        </Card>

                        {/* Continue Button */}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                mt: 2,
                                backgroundColor: "#C32032",
                                "&:hover": { backgroundColor: "#a71a28" },
                                display: 'flex',
                                gap: 1,
                                textTransform: 'none'
                            }}
                            onClick={() => console.log("Proceed with", selected)}
                        >
                            Continue<EastIcon />
                        </Button>
                    </Card>
                </Box>
                {/* order summary */}
                <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                    <Typography variant="h6" fontWeight="bold" mb={2}>
                        Order Summary
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography>Items ({items.length})</Typography>
                        <Typography>
                            €{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography>Shipping</Typography>
                        <Typography>
                            FREE
                        </Typography>
                    </Box>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography fontSize={18} fontWeight="bold">Order Total</Typography>
                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>
                            €{items.reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                        </Typography>
                    </Box>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Box>
                        <Typography fontSize={18} fontWeight="bold">Delivery Address</Typography>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography sx={{ width: '60%' }}>Villa 25, Street 12B, Al Barsha 2
                            Near Al Barsha Mall
                            Dubai, United Arab Emirates<br />
                            ph.no: 123 456 7890  </Typography>
                    </Box>
                </Card>

            </Box>

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}


export default PaymentMethod;